import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ringraziamento',
  templateUrl: './ringraziamento.component.html',
  styleUrls: ['./ringraziamento.component.scss']
})
export class RingraziamentoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ringraziamento/ringraziamento.component.ts